<template>
    <div class="container-fluid">        
        <div class="flex-left-parent employee-info-header" >    
            <div>{{ $t('Year')}}</div>                    
            <input
                type="number"
                min="1900"
                max="2099"
                step="1"
                v-model="year"                   
            />    
        </div>  
    </div>
</template>
<script>
export default {
    props: ["year_init"],
    data() {
        return {
            year: this.year_init ? this.year_init : moment().year()
        };
    },
    created() {
        console.log(i18n);
    },
    methods: {}
};
</script>

